import React, {ReactElement, useMemo} from 'react';
import {useAppSelector} from '.';
import {selectStoreType} from '../slices/storesSlice';

const STORE_TYPE = {
  NON_EVENT: 'selfServe',
  EVENT: 'event'
};

const USER_TYPE = {
  ORGANIZER: 'organizer-footer',
  PARTICIPANT: 'store-layout-footer'
} as const;

type SupportInfoType = {
  phoneNumber?: string;
  email?: string;
  hours?: string | ReactElement;
};

type UserTypeKeys = keyof typeof USER_TYPE;
type CurrentUserType = typeof USER_TYPE[UserTypeKeys];

const SUPPORT_INFO = {
  nonEvent: {
    participant: {
      phoneNumber: '855-330-6775',
      email: 'onlinestores@customink.com',
      hours: 'Monday-Friday: 9am - 9pm ET'
    },
    organizer: {
      phoneNumber: '855-792-1402',
      email: 'TBD',
      hours: (
        <>
          8am-Midnight ET Mon-Fri &nbsp; | &nbsp; 10am-6pm ET Saturday &nbsp; |
          &nbsp; 10am-6pm ET Sunday
        </>
      )
    }
  },
  event: {
    participant: {
      phoneNumber: '800-992-2728',
      email: 'service@customink.com',
      hours: (
        <>
          8am-Midnight ET Mon-Fri &nbsp; | &nbsp; 10am-6pm ET Saturday &nbsp; |
          &nbsp; 10am-6pm ET Sunday
        </>
      )
    },
    organizer: {
      phoneNumber: '800-992-2728',
      email: 'service@customink.com',
      hours: (
        <>
          8am-Midnight ET Mon-Fri &nbsp; | &nbsp; 10am-6pm ET Saturday &nbsp; |
          &nbsp; 10am-6pm ET Sunday
        </>
      )
    }
  }
};

export const useSupportInfo = (
  currentUser: CurrentUserType
): SupportInfoType => {
  const storeType = useAppSelector(selectStoreType);

  const supportInfo = useMemo<SupportInfoType>(() => {
    switch (storeType) {
      case STORE_TYPE.NON_EVENT: {
        if (currentUser === USER_TYPE.ORGANIZER) {
          return SUPPORT_INFO.nonEvent.organizer;
        }
        return SUPPORT_INFO.nonEvent.participant;
      }
      case STORE_TYPE.EVENT: {
        if (currentUser === USER_TYPE.ORGANIZER) {
          return SUPPORT_INFO.event.organizer;
        }
        return SUPPORT_INFO.event.participant;
      }
      default: {
        return SUPPORT_INFO.event.participant;
      }
    }
  }, [storeType, currentUser]);

  return supportInfo;
};

export default useSupportInfo;
